import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, Check, ChevronRight } from "lucide-react";

const PHASE_COLOUR = { ESTABLISH: "#E65322", PROGRESS: "#3B82F6", "PROGRESS HARDER": "#10B981", "OWN IT": "#7C3AED" };
const GROUPS = [["ESTABLISH", [1, 2, 3]], ["PROGRESS", [4, 5, 6]], ["PROGRESS HARDER", [7, 8, 9]], ["OWN IT", [10, 11, 12]]];

export default function Learn() {
  const [data, setData] = useState({ lessons: [], current_week: 1 });
  useEffect(() => { api.get("/lessons").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-8" data-testid="learn-page">
      <div>
        <div className="label-eyebrow">Learn · Week {data.current_week} of 12</div>
        <h1 className="wordmark mt-3 text-4xl md:text-5xl uppercase">Your Longevity Foundation.</h1>
        <p className="mt-2 text-sm text-muted-foreground max-w-xl">Twelve short founder lessons — ~3 minutes each — with one practical action per week. Revisit any unlocked lesson anytime.</p>
      </div>
      {GROUPS.map(([phase, weeks]) => (
        <div key={phase} data-testid={`learn-phase-${phase.toLowerCase().replace(" ", "-")}`}>
          <div className="flex items-center gap-3 mb-3">
            <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: PHASE_COLOUR[phase] }} />
            <div className="label-eyebrow">{phase} · Weeks {weeks[0]}–{weeks[2]}</div>
          </div>
          <div className="grid md:grid-cols-3 gap-3">
            {weeks.map((wk) => {
              const lesson = data.lessons.find((l) => l.week === wk);
              if (!lesson) return (
                <div key={wk} className="rounded-lg p-5 border border-border bg-muted/50" data-testid={`lesson-week-${wk}`}>
                  <div className="flex justify-between items-start"><div className="label-eyebrow">Week {wk}</div><Lock size={14} className="text-muted-foreground" /></div>
                  <div className="mt-2 font-head uppercase text-base text-muted-foreground">Unlocks in Week {wk}</div>
                </div>
              );
              return (
                <Link key={wk} to={`/app/lesson/${wk}`} className="rounded-lg p-5 border border-border bg-card lift block min-h-[44px]" data-testid={`lesson-week-${wk}`}>
                  <div className="flex justify-between items-start">
                    <div className="label-eyebrow">Week {wk}{wk > data.current_week ? " · Preview" : ""}</div>
                    {lesson.completed ? <Check size={14} className="text-emerald-600" /> : <ChevronRight size={14} className="text-muted-foreground" />}
                  </div>
                  <div className="mt-2 font-head uppercase text-base leading-snug">{lesson.title}</div>
                  <p className="mt-2 text-xs text-muted-foreground leading-relaxed">{lesson.body}</p>
                  <div className="mt-3 pt-3 border-t border-border/60 text-[11px] uppercase tracking-widest text-primary">Action · {lesson.action_title}</div>
                </Link>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
